import * as React from "react";
import { AutoCompleteInput, Checkbox, ColorPallet, ColorPicker, Input, Label, PortalContainer } from "uxp/components";
import { findAvailableFields, findAvailableFieldsInSchema, IUIPropertyDefinition } from "../../../common/common";
import { ColorPickerDialog, CustomColorPicker, IColorForRange, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle, RemoveButton } from "../../../common/ui-props/common";
import jp from 'jsonpath'
import { FAIcon as FontAwesomeIcon } from '../../../common/components/FAIcon';
import { bindContainerId, hasValue } from "../../../../util";
import classNames from "classnames";


export interface IGaugeProps {
    min: number,
    max: number,
    label: string,
    legend: boolean,
    gradient: boolean,
    colors: Array<{ color: string, stopAt: number }>,
    refreshInterval: number,
    channel?: string,
    backgroundColor?: string,
    labelColor?: string
    needleColor?: string
    tickColor?: string
    thickness?: number
    largeTick?: number
    smallTick?: number
    field: string
}



export interface INewColorButton {
    onAddNew: (colorForRange: { color: string, stopAt: number }) => void,
}

export const NewColorButton: React.FunctionComponent<INewColorButton> = (props) => {

    const [showColorPicker, setShowColorPicker] = React.useState<boolean>(false)
    const [newColorForRange, setNewColorForRange] = React.useState<{ color: string, stopAt: number }>({ color: '#fff', stopAt: 3 })

    let addButtonRef = React.useRef(null)
    const newColorForRangeRef = React.useRef<{ color: string, stopAt: number }>({ color: '#fff', stopAt: 3 })

    React.useEffect(() => {
        setNewColorForRange({ ...newColorForRange, stopAt: 3 })
    }, [showColorPicker])

    React.useEffect(() => {
        console.log('new col', newColorForRange);

    }, [newColorForRange])

    return (
        <>
            <div
                className="plus"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    cursor: 'pointer'
                }}
                ref={addButtonRef}
                onClick={() => {
                    setShowColorPicker(true)
                }}
            >
                <FontAwesomeIcon icon={['fas', 'plus']} />
            </div>

            <ColorPickerDialog
                onClose={() => {
                    setShowColorPicker(false)
                    props.onAddNew(newColorForRangeRef.current)
                }}
                show={showColorPicker}
                onChange={(v) => {
                    console.log('color change', v);

                    setNewColorForRange(prev => ({
                        ...prev,
                        color: v.color,
                        stopAt: v.from,
                    }))

                    newColorForRangeRef.current = {
                        color: v.color,
                        stopAt: v.from,
                    }
                }}
                triggerButtonRef={addButtonRef}
                colorForRange={{
                    color: newColorForRange?.color,
                    from: newColorForRange?.stopAt,
                }}
            />
        </>
    )
}


export function GuageProperty(title: string, props: IGaugeProps): IUIPropertyDefinition<IGaugeProps> {
    return {
        defaults: props,
        render: (props, uxpContext, data, containerId) => {
            let [selectedColorForRangeIndex, setSelectedColorForRangeIndex] = React.useState<number>()

            const [showColorPicker, setShowColorPicker] = React.useState<boolean>(false)


            let _props = props.uiProps
            let possibleValues = {};
            findAvailableFields(props.parentUIProps.source, props.parentUIProps.datasources, possibleValues);
            let pv = Object.keys(possibleValues);
            pv.sort();
            return <PropertyContainer>
                <PropertyContainerTitle>{title}</PropertyContainerTitle>
                <PropertyGroup>
                    <Property id={bindContainerId('field', containerId)}>
                        <PropertyTitle>Field</PropertyTitle>
                        <AutoCompleteInput
                            options={pv}
                            value={_props.field || ''}
                            onChange={s => {

                                jp.apply(_props, '$.field', () => (s))
                                props.onChange(_props)
                            }}
                            className="widget-designer-input"
                        />

                    </Property>

                    <Property>
                        <PropertyTitle>Min value</PropertyTitle>
                        <Input
                            type="number"
                            value={_props?.min?.toString() || '0'}
                            onChange={s => {
                                let num = Number(s) || 0
                                jp.apply(_props, '$.min', () => (num))
                                props.onChange(_props)
                            }}
                        />

                    </Property>
                    <Property>
                        <PropertyTitle>Max value</PropertyTitle>
                        <Input
                            type="number"
                            value={_props?.max?.toString() || '0'}
                            onChange={s => {
                                let num = Number(s) || 0
                                jp.apply(_props, '$.max', () => (num))
                                props.onChange(_props)
                            }}
                        />

                    </Property>

                    <Property>
                        <PropertyTitle>Units</PropertyTitle>
                        <Input
                            value={_props?.label || ''}
                            onChange={s => {
                                jp.apply(_props, '$.label', () => (s))
                                props.onChange(_props)
                            }}
                        />

                    </Property>
                    <Property>
                        <PropertyTitle>Refresh Interval (ms)</PropertyTitle>
                        <Input
                            type="number"
                            value={_props?.refreshInterval?.toString() || '0'}
                            onChange={s => {
                                let num = Number(s) || 0
                                jp.apply(_props, '$.refreshInsterval', () => (num))
                                props.onChange(_props)
                            }}
                        />

                    </Property>

                    <Property>
                        <PropertyTitle>Channel Name</PropertyTitle>
                        <Input
                            value={_props?.channel || ''}
                            onChange={s => {
                                jp.apply(_props, '$.channel', () => (s))
                                props.onChange(_props)
                            }}
                        />

                    </Property>



                    <Property>
                        <Checkbox
                            checked={_props?.legend}
                            onChange={s => {
                                jp.apply(_props, '$.legend', () => (s))
                                props.onChange(_props)
                            }}
                            label="Show Legend"
                        />

                    </Property>

                </PropertyGroup>

                <PropertyGroup>
                    <div className="wd-ui-property-group-title" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        Colors

                        <NewColorButton
                            onAddNew={(v) => {
                                let _colors = _props?.colors || []
                                _colors.push(v)

                                jp.apply(_props, `$.colors`, () => (_colors))
                                props.onChange(_props)
                            }}
                        />

                    </div>

                    <Property>
                        <PropertyTitle>Colors</PropertyTitle>

                        <div className="wd-gauge-config-colors">

                            {_props?.colors?.map((s, i) => {

                                return <div className="row">
                                    <div className="color">
                                        <ColorPicker
                                            color={s?.color}
                                            onChange={(s) => {
                                                jp.apply(_props, `$.colors[${i}].color`, () => (s))
                                                props.onChange(_props)
                                            }}
                                            className='color-input'
                                            position='right'
                                        />

                                    </div>
                                    <div className="stop-at">
                                        <Label className="up-to">Up to <span className="value">{s?.stopAt?.toString() || '0'}</span></Label>
                                    </div>

                                    <div className="close">
                                        <RemoveButton onClick={() => {
                                            let _colors = _props?.colors || []
                                            _colors.splice(i, 1)

                                            jp.apply(_props, `$.colors`, () => (_colors))
                                            props.onChange(_props)
                                        }} />
                                    </div>
                                </div>
                            })}
                        </div>

                    </Property>
                    <Property>
                        <Checkbox
                            checked={_props?.gradient}
                            onChange={s => {
                                jp.apply(_props, '$.gradient', () => (s))
                                props.onChange(_props)
                            }}
                            label="Smooth color transitions"
                        />

                    </Property>

                </PropertyGroup>

                <PropertyGroup>
                    <PropertyGroupTitle>Styling</PropertyGroupTitle>

                    <Property>
                        <PropertyTitle>Guage Thickness</PropertyTitle>
                        <Input
                            type="number"
                            value={_props?.thickness?.toString() || '0'}
                            onChange={s => {
                                let num = Number(s) || 0
                                jp.apply(_props, '$.thickness', () => (num))
                                props.onChange(_props)
                            }}
                            inputAttr={{
                                min: '0'
                            }}
                        />
                    </Property>

                    <Property id={bindContainerId('large-tick', containerId)}>
                        <PropertyTitle>Large Tick</PropertyTitle>
                        <Input
                            type="number"
                            value={_props?.largeTick?.toString() || '0'}
                            onChange={s => {
                                let num = Number(s) || 0
                                jp.apply(_props, '$.largeTick', () => (num))
                                props.onChange(_props)
                            }}
                            inputAttr={{
                                min: '1',
                                max: '6'
                            }}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Small Tick</PropertyTitle>
                        <Input
                            type="number"
                            value={_props?.smallTick?.toString() || '0'}
                            onChange={s => {
                                let num = Number(s) || 0
                                jp.apply(_props, '$.smallTick', () => (num))
                                props.onChange(_props)
                            }}
                            inputAttr={{
                                min: '1',
                                max: '3'
                            }}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Tick Color</PropertyTitle>
                        <CustomColorPicker contextData={props.contextData}
                            color={_props?.tickColor || ''}
                            onChange={s => {
                                jp.apply(_props, '$.tickColor', () => (s))
                                props.onChange(_props)
                            }}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Background Color</PropertyTitle>
                        <CustomColorPicker contextData={props.contextData}
                            color={_props?.backgroundColor || ''}
                            onChange={s => {
                                jp.apply(_props, '$.backgroundColor', () => (s))
                                props.onChange(_props)
                            }}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Label Color</PropertyTitle>
                        <CustomColorPicker contextData={props.contextData}
                            color={_props?.labelColor || ''}
                            onChange={s => {
                                jp.apply(_props, '$.labelColor', () => (s))
                                props.onChange(_props)
                            }}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Needle Color</PropertyTitle>
                        <CustomColorPicker contextData={props.contextData}
                            color={_props?.needleColor || ''}
                            onChange={s => {
                                jp.apply(_props, '$.needleColor', () => (s))
                                props.onChange(_props)
                            }}
                        />
                    </Property>

                </PropertyGroup>


            </PropertyContainer>
        }
    };
}
